import axios from "axios";
import { AppConfig } from "../../shared/utilities/AppConfig";
import { PoliceProfilesResponse } from "../../shared/definitions/internationalTypes";

export type GetPoliceProfilesParams = {
  page?: number;
};

export default async function getPoliceProfiles(
  params: GetPoliceProfilesParams = {},
) {
  const { data } = await axios.get<PoliceProfilesResponse>(
    `${AppConfig.API_URL}/kepolisian_internasional`,
    { params },
  );

  return data;
}
